// ---------------------------------------------------------------------------
// Signets (favoris) de l'utilisateur — enregistrement partagé.
//
// Le magasin d'une page (`{favorites: [url…], favorite_labels: {url: nom}}`) EST
// le corps du POST : les clés portent leurs noms serveur pour que l'aller-retour
// soit l'identité (cf. userFavoritesProcessor).
//
// POURQUOI ICI ET PAS EN YAML — l'enregistrement se ferait très bien avec un
// `submitData`, mais il doit être SUIVI d'une relecture du menu (le classement
// des signets est calculé par le back). reactive-json enchaîne ça avec
// `on: response`… qu'il ne dispatche que sur l'élément DOM de l'événement
// d'origine : une réaction déclenchée par un événement CUSTOM n'en a pas, et
// l'événement `response` n'est alors envoyé à personne (`executeHttpRequest`).
// Lancer les deux sur le même événement custom ferait courir la relecture contre
// l'écriture. On enregistre donc ici, et on n'émet l'événement — celui que le
// YAML écoute pour relire le menu — qu'UNE FOIS LA RÉPONSE REÇUE.
//
// `window.fetch` est déjà patché pour porter le jeton CSRF et les cookies
// (fetchPatch.js) : rien à ajouter ici.
// ---------------------------------------------------------------------------

export const FAVORITES_URL = '/api/user/prefs';

/** L'événement émis une fois les signets écrits ; le YAML relit le menu dessus. */
export const FAVORITES_EVENT = 'favoriteschanged';

const EMPTY = { favorites: [], favorite_labels: {} };

/** Normalise un magasin (ou une réponse serveur) vers la forme attendue. */
export const normalizeFavorites = (store) => ({
  favorites: Array.isArray(store?.favorites)
    ? store.favorites.filter((u) => typeof u === 'string' && u)
    : [],
  favorite_labels: store?.favorite_labels && typeof store.favorite_labels === 'object'
    ? store.favorite_labels
    : {},
});

/**
 * Écrit les signets et rend l'état du serveur (ou `null` si l'écriture a échoué,
 * auquel cas l'appelant garde son état optimiste — un signet perdu ne casse rien
 * et le prochain chargement dira la vérité).
 */
export const saveFavorites = async (store) => {
  const prefs = normalizeFavorites(store);
  try {
    const response = await fetch(FAVORITES_URL, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prefs }),
    });
    if (!response.ok) return null;
    const body = await response.json();
    return normalizeFavorites(body?.prefs ?? EMPTY);
  } catch {
    return null;
  }
};
